// dependencies.
import styled from 'styled-components'
// components.
import { Body } from '../Typography'
import { Input } from '../Form'
// utils.
import { useDimensions } from '../../js/hooks'

// partials.
const Wrapper = styled.div({
  display: 'flex',
  flexDirection: (props) => (props.column ? 'column' : 'row'),
  gap: (props) => (props.isTablet ? '8px' : '16px'),
  maxWidth: '900px',
  width: '100%',
})

// main component.
const FilterSearch = ({
  label,
  onChange = () => {},
  placeholder = 'Buscar...',
  defaultValue = '',
}) => {
  const { isMobile, isTablet } = useDimensions()

  // return content.
  return (
    <Wrapper column={!!label} isTablet={isTablet}>
      {label && (
        <Body type="caption" color="grey">
          {label}
        </Body>
      )}
      <Input
        isMobile={isMobile}
        name="search"
        iconL="search"
        placeholder={placeholder}
        onChange={(value) => onChange(value)}
        defaultValue={defaultValue}
      />
    </Wrapper>
  )
}

export default FilterSearch
